import { useState } from 'react';
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  Paper,
  Snackbar,
  Alert,
} from '@mui/material';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const form = new FormData();
      form.append('form-name', 'contact');
      Object.keys(formData).forEach(key => {
        form.append(key, formData[key]);
      });

      const response = await fetch('/', {
        method: 'POST',
        body: form
      });

      if (response.ok) {
        setSnackbar({
          open: true,
          message: 'Το μήνυμά σας στάλθηκε επιτυχώς! Θα επικοινωνήσουμε μαζί σας σύντομα.',
          severity: 'success',
        });
        setFormData({ name: '', email: '', phone: '', message: '' });
      } else {
        throw new Error('Failed to send message');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setSnackbar({
        open: true,
        message: 'Δεν ήταν δυνατή η αποστολή του μηνύματος αυτή τη στιγμή. Παρακαλώ δοκιμάστε ξανά αργότερα.',
        severity: 'error',
      });
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom align="center">
          Επικοινωνία
        </Typography>
        <Typography variant="body1" paragraph align="center" sx={{ mb: 4 }}>
          Έχετε ένα project στο μυαλό σας; Επικοινωνήστε μαζί μας σήμερα.
        </Typography>

        <Box 
          component="form" 
          onSubmit={handleSubmit} 
          name="contact"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          noValidate
        >
          <input type="hidden" name="form-name" value="contact" />
          <input type="hidden" name="bot-field" />
          
          <TextField
            required
            fullWidth
            label="Όνομα"
            name="name"
            value={formData.name}
            onChange={handleChange}
            margin="normal"
            helperText="Το πεδίο είναι υποχρεωτικό"
          />
          <TextField
            required
            fullWidth
            label="Email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            margin="normal"
            helperText="Το πεδίο είναι υποχρεωτικό"
          />
          <TextField
            fullWidth
            label="Τηλέφωνο"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            margin="normal"
          />
          <TextField
            required
            fullWidth
            label="Μήνυμα"
            name="message"
            multiline
            rows={4}
            value={formData.message}
            onChange={handleChange}
            margin="normal"
            helperText="Το πεδίο είναι υποχρεωτικό"
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            sx={{ mt: 3 }}
          >
            Αποστολή Μηνύματος
          </Button>
        </Box>
      </Paper>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default Contact; 